import { WifiOff } from 'lucide-react';
import { useIsOffline } from '../lib/useIsOffline';

/**
 * App-level "you're offline" strip, rendered under the top bar on every signed
 * in page.
 *
 * Carries the part of the message the per-surface {@link OfflineState} cannot:
 * that *writes* are unavailable too, and that anything still on screen (a list
 * rendered from cache before the connection dropped) may now be out of date.
 * A page-level state only appears where a query had nothing cached to show, so
 * without this a user looking at stale-but-populated screens would get no
 * signal at all.
 *
 * `role="status"` + `aria-live="polite"` so a screen reader announces the
 * transition without interrupting whatever the user is doing; `polite` rather
 * than `assertive` because losing a connection is not an emergency and the
 * state is recoverable on its own.
 */
export function OfflineBanner() {
  const offline = useIsOffline();
  if (!offline) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center gap-2 border-b border-line bg-cream px-4 py-2 font-sans text-[12px] text-navy"
    >
      <WifiOff size={14} strokeWidth={2} aria-hidden className="shrink-0 text-slate" />
      <span>
        You're offline. Some information may be out of date, and changes can't be saved until your connection is back.
      </span>
    </div>
  );
}
